import {IMarketInfo} from 'types';
import {GET} from './fetcher';

export async function query_current_price({queryKey}: {queryKey: [string, string]}): Promise<any | undefined> {
	const exchange_ticker = queryKey[1];
	const exchange = exchange_ticker.split('/')[0];
	const ticker = exchange_ticker.split('/')[1];

	const resp = await GET(`/v1/market/price?exchange=${exchange}&ticker=${ticker}`);
	return resp.data;
}

export async function query_market_info({queryKey}: {queryKey: [string, string]}): Promise<IMarketInfo | undefined> {
	const exchange_ticker = queryKey[1];
	const exchange = exchange_ticker.split('/')[0];
	const ticker = exchange_ticker.split('/')[1];

	const resp = await GET(`/v1/market?exchange=${exchange}&ticker=${ticker}`);
	return resp.data.market_info;
}

export async function query_market_list({queryKey}: {queryKey: [string, string]}): Promise<string[]> {
	const exchange = queryKey[1];
	const resp = await GET('/v1/market/list?exchange=' + exchange);
	return resp.data.markets;
}
